import { render, staticRenderFns } from "./sberbank.vue?vue&type=template&id=fe9aed08&scoped=true"
var script = {}
import style0 from "./sberbank.vue?vue&type=style&index=0&id=fe9aed08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe9aed08",
  null
  
)

export default component.exports